import { css } from '@emotion/core'
import parse from 'html-react-parser'
import * as React from 'react'

import { ctaInlineBreakPoint, longCopyBreakPoint } from '../../constants/breakPoints'
import { breakpoints } from '../../constants/breakPoints'
import { isMobile } from '../../helpers/common'
import { CTABookADemoProps } from '../../interfaces/cta'
import { Button } from '../Button'
import Image from '../Image'
import { Link } from '../Link'

const CTABookADemo: React.FunctionComponent<CTABookADemoProps> = ({ type = 'general', isSidebarCta = false }) => {
  const getCtaBookADemoData = (type: 'general' | 'insights' | 'prioritization' | 'product-strategy' | 'roadmaps') => {
    switch (type) {
      case 'general':
        return { ctaTitle: 'Make product <br class="hide-on-small " /> management easy', imgSrc: 'general' }
      case 'insights':
        return {
          ctaTitle: 'All product feedback <br class="hide-on-small" /> in one place',
          imgSrc: 'insights',
        }
      case 'prioritization':
        return {
          ctaTitle: 'Prioritize with <br class="hide-on-small" /> confidence',
          imgSrc: 'prioritization',
        }
      case 'product-strategy':
        return {
          ctaTitle: 'Create an effective <br class="hide-on-small" /> product strategy',
          imgSrc: 'general',
        }
      case 'roadmaps':
        return { ctaTitle: 'Build great <br class="hide-on-small" /> roadmaps', imgSrc: 'roadmaps' }
    }
  }
  const { ctaTitle, imgSrc } = getCtaBookADemoData(type)

  return (
    <div className="purple-bg with-box-shadow" css={containerStyle(isSidebarCta)}>
      {isSidebarCta && (
        <Link className="scale-on-hover" href="/cta/sidebar/book-a-demo/index/" css={imageStyle(isSidebarCta)}>
          <Image
            src={type === 'roadmaps' ? 'cta/general-small.webp' : `cta/${imgSrc}-small.webp`}
            alt="airfocus modular platform"
          />
        </Link>
      )}

      <div css={contentStyle(isSidebarCta)}>
        <div className={`blue-text ${isSidebarCta ? 'strong-body-2' : 'heading4'}`} css={blueTextStyle(isSidebarCta)}>
          Demo
        </div>
        {isSidebarCta ? (
          <div className="cta-sidebar-title black-text">{parse(ctaTitle)}</div>
        ) : (
          <h3 className="heading3 black-text no-margin">{parse(ctaTitle)}</h3>
        )}
        <Button link={`/cta/${isSidebarCta ? 'sidebar' : 'inline'}/book-a-demo/index/`} css={buttonStyle(isSidebarCta)}>
          Book a demo
        </Button>
      </div>

      {!isSidebarCta && (
        <Link className="scale-on-hover" href="/cta/inline/book-a-demo/index/" css={imageStyle(isSidebarCta)}>
          <Image
            src={`cta/${isMobile(breakpoints.small) ? 'demo-small' : imgSrc}.webp`}
            alt="airfocus modular platform"
          />
        </Link>
      )}
    </div>
  )
}

export default CTABookADemo

const containerStyle = (isSidebarCta: boolean) => css`
  // richt-text (center column) always has a slight margin-top for which we need to align
  ${isSidebarCta ? 'margin-top: 0.25rem' : 'margin: 2rem 0'};
  ${isSidebarCta ? 'position: sticky; top: 6rem;' : 'position: relative;'};
  border-radius: 0.5rem;
  padding: ${isSidebarCta ? '0 0 1.25rem' : '3rem 2rem'};
  overflow: hidden;

  @media screen and (max-width: ${breakpoints.small}px) {
    margin-top: 3rem;
    padding: 2rem;
    overflow: visible;
  }
`

const contentStyle = (isSidebarCta: boolean) => css`
  ${isSidebarCta && 'padding: min(105%, 13rem) 1.25rem 0'};
`

const blueTextStyle = (isSidebarCta: boolean) => css`
  ${isSidebarCta && 'margin-bottom: 0.25rem'};
`

const buttonStyle = (isSidebarCta: boolean) => css`
  margin-top: ${isSidebarCta ? '1rem' : '1.5rem'};
  ${isSidebarCta && 'padding: 0.75rem 1rem; width: 100%;'};
`

const imageStyle = (isSidebarCta: boolean) => css`
  display: block;

  ${isSidebarCta
    ? `
    position: absolute;
    width: 100%;
    max-width: 200px;
    top: -8px;
    right: -1px;
    `
    : `
    position: absolute;
    width: 400px;
    top: 0;
    right: -8px;

    @media screen and (min-width: ${longCopyBreakPoint + 1}px) and (max-width: ${breakpoints.xlarge}px) {
      right: -105px; 
    }

    @media screen and (max-width: ${longCopyBreakPoint}px) {
      width: 60%;
      right: -5px;
    }
    
    @media screen and (max-width: ${ctaInlineBreakPoint}px) {
      width: 400px;
      top: 5px;
      left: 50%;
    }

    @media screen and (max-width: ${breakpoints.medium}px) {
      width: 370px;
      top: 3%;
      left: initial;
    }

    @media screen and (max-width: ${breakpoints.small}px) {
      width: 8rem; 
      top: -3.5rem;
      right: -1rem;
    }
  `}
`
